// Languages
import languageAR from './ar/index.js'
import languageDE from './de/index.js'
import languageEN from './en/index.js'
import languageRU from './ru/index.js'
import languageTR from './tr/index.js'
import languageUA from './ua/index.js'

// Translations: Index
const translations = {
	ar: { common: languageAR },
	de: { common: languageDE },
	en: { common: languageEN },
	ru: { common: languageRU },
	tr: { common: languageTR },
	ua: { common: languageUA }
}

// Export
export default translations
